module.exports = __webpack_public_path__ + "e8f5a9b64166ec5e22e92d2002547709.svg";